module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.b18799dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/picudo_banano/curativa/malphos_1000ce.png
// module id = 1165
// module chunks = 3